import React, { Component, PropTypes as T } from 'react';
import ReactDOM from 'react-dom';
import AuthService from '../../utils/AuthService';
import FlatButton from 'material-ui/FlatButton';
import googleLogo from '../../images/google.png'; // Tell Webpack this JS file uses this image
import './SignInButtons.css';

export default class SignInButtons extends Component {

  static contextTypes = {
    router: T.object
  }

  static propTypes = {
    location: T.object,
    auth: T.instanceOf(AuthService)
  }

  getAuthParams() {
    return {
      email: ReactDOM.findDOMNode(this.refs.email).value,
      password: ReactDOM.findDOMNode(this.refs.password).value
    }
  }

  login(e) {
    e.preventDefault()
    const { email, password } = this.getAuthParams();
    this.props.auth.login(email, password)
  }

  signup() {
    const { email, password } = this.getAuthParams();
    this.props.auth.signup(email, password)
  }

  loginWithGoogle() {
    this.props.auth.loginWithGoogle();
  }

  render () {
    const styles = {
      googleLabel: {
        textTransform: 'none',
        fontWeight: 400,
        marginLeft: '10px'
      },
    }
    return (
      <div>
        <div className="sign-in-heading">
          Sign In
        </div>
        <div className="sign-in-subheading">
          Please sign in to save and share your favorite pairings.
          You won't get any spam from us, we promise.
        </div>
        <div className="sign-in-container">
          <FlatButton
            label="Continue with Google"
            labelStyle={styles.googleLabel}
            icon={<img src={googleLogo} alt="Google logo" width="20px" />}
            backgroundColor="white"
            hoverColor="white"
            className="btn-google"
            style={{marginBottom: '10px'}}
            onClick={this.loginWithGoogle.bind(this)}
          />
          <div className="sign-in-separator">
            or
          </div>
          <form onSubmit={this.login.bind(this)}>
            <input
              type="email"
              ref="email"
              className="sign-in-input"
              placeholder="your_email@example.com"
              onChange={this.handleUrlChange}
              required />
            <input
              type="password"
              ref="password"
              className="sign-in-input"
              placeholder="Password"
              onChange={this.handleUrlChange}
              required />
            <FlatButton
              label="Sign In"
              className="sign-in-submit-button"
              backgroundColor="#30353a"
              hoverColor="#686C6F"
              type='submit'
            />
            <FlatButton
              label="or, sign up"
              className="sign-up-button"
              backgroundColor="#EFEFEF"
              hoverColor="#DDDDDD"
              onClick={this.signup.bind(this)}
            />
          </form>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/signin/SignInButtons.jsx